/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
import BrandHeader, { BrandHeaderFragment } from '../Brand/BrandHeader';
import ProducerStand, { ProducerStandFragment } from './ProducerStand';

export default function ProducerHeader({
  producer,
  onDark = false,
  gutter = 2,
  as,
  ...rest
}) {
  return (
    <React.Fragment>
      <ProducerStand
        producer={producer || {}}
        sx={{ paddingBottom: gutter, color: onDark ? 'onDark' : 'lighterText' }}
      />
      <BrandHeader as={as} brand={producer || {}} {...rest} />
    </React.Fragment>
  );
}

export const fragment = graphql`
  fragment ProducerHeader on Producer {
    ...ProducerStand
    ...BrandHeader
  }
`;

export const ProducerHeaderFragment = gql`
  ${ProducerStandFragment}
  ${BrandHeaderFragment}
  fragment ProducerHeader on AbstractBrand {
    ...ProducerStand
    ...BrandHeader
  }
`;
